import React, { useState } from 'react';
import { settingsAPI } from '../../utils/api';
import { toast } from 'react-toastify';

const SettingsTab = ({ 
  settings, 
  setSettings,
  loadSettings
}) => {
  const [adminEmail, setAdminEmail] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [saving, setSaving] = useState(false);

  // Admin E-Mail aus Settings laden
  React.useEffect(() => {
    console.log('Settings received:', settings);
    if (settings && settings.admin_email) {
      console.log('admin_email structure:', settings.admin_email);
      // Settings können {value, description} Struktur haben
      const emailValue = typeof settings.admin_email === 'object' ? 
        settings.admin_email.value : settings.admin_email;
      console.log('Extracted email value:', emailValue);
      setAdminEmail(emailValue || '');
    }
  }, [settings]);

  const handleSave = async () => {
    if (!adminEmail.trim()) {
      toast.error('Bitte E-Mail-Adresse eingeben');
      return;
    }

    try {
      setSaving(true);
      const response = await settingsAPI.updateSetting('admin_email', adminEmail);
      if (response.success) {
        toast.success('Admin E-Mail wurde gespeichert');
        setIsEditing(false);
        await loadSettings();
      }
    } catch (error) {
      console.error('Fehler beim Speichern:', error);
      toast.error('Fehler beim Speichern der E-Mail');
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    const emailValue = typeof settings.admin_email === 'object' ? 
      settings.admin_email.value : settings.admin_email;
    setAdminEmail(emailValue || '');
    setIsEditing(false);
  };

  return (
    <div className="settings-section">
      <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px'}}>
        <h3>E-Mail Einstellungen</h3>
      </div>

      <div style={{background: '#f8f9fa', padding: '30px', borderRadius: '8px', maxWidth: '600px'}}>
        <div style={{marginBottom: '20px'}}>
          <h4 style={{marginBottom: '8px'}}>📧 Admin E-Mail Adresse</h4>
          <p style={{color: '#666', fontSize: '0.9em', marginBottom: '15px'}}>
            An diese E-Mail-Adresse werden Benachrichtigungen über neue Spielanmeldungen gesendet.
          </p>
        </div>

        <div style={{marginBottom: '20px'}}>
          <label style={{display: 'block', marginBottom: '8px', fontWeight: 'bold'}}>
            E-Mail Adresse:
          </label>
          
          {isEditing ? (
            <div style={{display: 'flex', gap: '10px', alignItems: 'center'}}>
              <input
                type="email"
                value={adminEmail}
                onChange={(e) => setAdminEmail(e.target.value)}
                placeholder="admin@example.com"
                style={{
                  flex: 1,
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  fontSize: '14px'
                }}
                autoFocus
              />
              <button
                onClick={handleSave}
                className="btn btn-success"
                disabled={saving}
              >
                {saving ? 'Speichere...' : '✅ Speichern'}
              </button>
              <button
                onClick={handleCancel}
                className="btn btn-secondary"
                disabled={saving}
              >
                Abbrechen
              </button>
            </div>
          ) : (
            <div style={{display: 'flex', gap: '10px', alignItems: 'center'}}>
              <div style={{
                flex: 1,
                padding: '10px',
                background: 'white',
                border: '1px solid #ddd',
                borderRadius: '4px',
                minHeight: '40px',
                display: 'flex',
                alignItems: 'center'
              }}>
                {adminEmail ? (
                  <span>{adminEmail}</span>
                ) : (
                  <span style={{color: '#999', fontStyle: 'italic'}}>Noch keine E-Mail konfiguriert</span>
                )}
              </div>
              <button
                onClick={() => setIsEditing(true)}
                className="btn btn-primary"
              >
                ✏️ Bearbeiten
              </button>
            </div>
          )}
        </div>

        <div style={{
          background: '#e3f2fd',
          padding: '15px',
          borderRadius: '6px',
          border: '1px solid #90caf9'
        }}>
          <div style={{display: 'flex', alignItems: 'flex-start', gap: '8px'}}>
            <span style={{fontSize: '16px'}}>💡</span>
            <div>
              <strong>Hinweis:</strong> Wenn sich jemand für ein Spiel anmeldet, erhältst du automatisch eine E-Mail an diese Adresse mit den Anmeldungsdetails.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsTab;
